import Vue from 'vue'
import VueRouter from 'vue-router'
import LocalStorage from 'modules/LocalStorage'
import ga from 'ga'

let token = null

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    name: 'auth',
    meta: {
      checkAuth: true
    },
    component: view('auth/Auth'),
    children: [
      {
        path: 'login',
        name: 'login',
        meta: {
          title: 'Login',
          checkAuth: true
        },
        component: view('auth/Login')
      },
      {
        path: 'invite',
        name: 'invite',
        meta: {
          title: 'Invitation',
          checkAuth: true
        },
        component: view('auth/Invite')
      },
      {
        path: 'reset',
        name: 'password-reset',
        meta: {
          title: 'Reset Password',
          checkAuth: true
        },
        component: view('auth/password/Reset')
      },
      {
        path: 'signup',
        name: 'signup',
        meta: {
          title: 'Sign Up',
          checkAuth: true
        },
        component: view('auth/SignUp')
      }
    ]
  },
  {
    path: '/schedule',
    name: 'schedule',
    meta: {
      title: 'Schedule'
    },
    component: view('schedule/Schedule')
  },
  {
    path: '/tasks',
    name: 'tasks',
    meta: {
      title: 'Tasks'
    },
    component: view('dashboard/Dashboard')
  },
  {
    path: '/projects',
    name: 'projects',
    meta: {
      title: 'Projects'
    },
    component: view('projects/Projects')
  },
  {
    path: '/messages',
    name: 'messages',
    meta: {
      title: 'Messages'
    },
    component: view('messages/Messages')
  },
  {
    path: '/designers',
    name: 'designers',
    meta: {
      title: 'Designers'
    },
    component: view('designers/Designers')
  },
  {
    path: '/project/:id',
    name: 'project',
    meta: {
      title: 'Project',
      bodyClass: 'background-gray-darkest-2'
    },
    component: view('project/Project')
  },
  {
    path: '/project/:id/subscription-completed',
    name: 'project-subscription-completed',
    meta: {
      title: 'Project',
      bodyClass: 'background-gray-darkest-2'
    },
    component: view('project/Project')
  },
  {
    path: '/project/:id/collect-payment-details',
    name: 'project-payment-details',
    meta: {
      title: 'Project',
      bodyClass: 'background-gray-darkest-2'
    },
    component: view('project/Project')
  },
  {
    path: '/users',
    name: 'users',
    meta: {
      title: 'Users'
    },
    component: view('users/Users')
  },
  {
    path: '/user',
    name: 'user',
    component: view('user/User'),
    children: [
      {
        path: 'settings',
        name: 'settings',
        meta: {
          title: 'Settings'
        },
        component: view('user/Settings')
      }
    ]
  },
  {
    path: '/onboard',
    name: 'onboard',
    component: view('onboard/Onboard'),
    meta: {
      title: 'Onboard',
      checkAuth: true
    }
  }
]

export const router = new VueRouter({
  mode: 'history',
  base: '/app/',
  routes
})

router.beforeEach(function (to, from, next) {
  token = LocalStorage.get('token')

  if (from.meta.bodyClass) {
    document.querySelector('body').classList.remove(from.meta.bodyClass)
  }

  if (!token && to.meta.checkAuth !== true) {
    next({name: 'login'})
  } else if (to.path === '/') {
    next({name: 'projects'})
  } else if (to.path === '/dashboard') { // TODO update temp solution
    next({name: 'tasks'})
  } else {
    next()
  }
})

router.afterEach(function (transition) {
  ga('send', 'pageview', '/app' + transition.path)

  if (transition.meta.bodyClass) {
    document.querySelector('body').classList.add(transition.meta.bodyClass)
  }
  document.querySelector('head title').innerHTML = 'Koncepted - ' + transition.meta.title
})

function view (name, resolve) {
  return function (resolve) {
    require(['components/pages/' + name + '.vue'], resolve)
  }
}



// WEBPACK FOOTER //
// ./src/modules/Router.js